import "./FeaturedProjects.css";
import { Link } from "react-router-dom";

import projectsData from "../../data/projectsData";
import ProjectCard from "./ProjectCard";

const FeaturedProjects = () => {
  const featuredProjects = projectsData.filter((project) => project.featured);

  return (
    <section className="featured-projects">
      <div className="projects-container">
        {/* =========================
            Section Heading
        ========================== */}

        <div className="projects-heading">
          <span className="section-tag">FEATURED PROJECTS</span>

          <h2>Building World-Class Sports Infrastructure</h2>

          <p>
            Explore some of our recently completed sports infrastructure
            projects delivered with precision, quality workmanship, and
            international construction standards.
          </p>
        </div>

        {/* =========================
              Project Grid
        ========================== */}

        <div className="projects-grid">
          {featuredProjects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>

        {/* =========================
            View All Button
        ========================== */}

        <div className="projects-footer">
          <Link to="/projects" className="view-projects-btn">
            View All Projects →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
